<!--
 * @Desc: 
 * @Author: lc
 * @Date: 2023-07-04 09:54:34
 * @LastEditors: lc
 * @LastEditTime: 2023-07-11 08:12:55
-->
<template>
  <div class="search-data">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :inline="true">
        <FormItem>
          <Button @click="showDraw(1)"
                  type="success"
                  class="f-r">添加赠送商品</Button>
        </FormItem>
        <!-- <FormItem>
          <Button @click="showDraw(2)"
                  type="success"
                  class="f-r">添加热搜活动</Button>
        </FormItem>
        <FormItem>
          <Button @click="showDraw(3)"
                  type="success"
                  class="f-r">添加热搜匠人</Button>
        </FormItem>
        <FormItem>
          <Button @click="showDraw(4)"
                  type="success"
                  class="f-r">添加热搜项目</Button>
        </FormItem>
        <FormItem>
          <Button @click="showDraw(5)"
                  type="success"
                  class="f-r">添加热搜定制</Button>
        </FormItem> -->
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showDrawStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="search"
            action="javascript:void(0)">
        <Table border
               :columns="columns1"
               ref="selection"
               :data="tablelist1"
               :loading="dataloading"></Table>
        <div style="margin: 10px;overflow: hidden">
          <div style="float: right;">
            <Page ref="listPage2"
                  :total="pages2.total"
                  :current="pages2.page"
                  :page-size="pages2.size"
                  show-elevator
                  show-total
                  @on-change="changePage2()"></Page>
          </div>
        </div>
        <Button @click="showModel()"
                type="success"
                class="f-r">请选择</Button>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showDrawStatus = false">确定</Button>
        <!-- <Button type="primary" @click="createHot()">提交</Button> -->
      </div>
      <Modal v-model="showModalStatus"
             title="热门搜索"
             @on-ok="ok">
        <Form :model="search_s"
              ref="search_s"
              :inline="true"
              action="javascript:void(0)">
          <FormItem>
            <Tag v-for="(item,index) in selected"
                 :key="index"
                 type="border"
                 closable
                 :color="getColor(index)"
                 @on-close="cancelRow(item,index)">{{item.good_title}}</Tag>
          </FormItem>
          <FormItem>
            <Input v-model="search_s.key"
                   clearable
                   placeholder="输入名称查找..."></Input>
          </FormItem>
          <FormItem>
            <Button type="primary"
                    @click="renderTable1('search_s')">查找</Button>
          </FormItem>
        </Form>
        <Table border
               :columns="columns2"
               ref="selection"
               :data="list"
               :loading="dataloading"></Table>
        <div style="margin: 10px;overflow: hidden">
          <div style="float: right;">
            <Page ref="listPage1"
                  :total="pages1.total"
                  :current="pages1.page"
                  :page-size="pages1.size"
                  show-elevator
                  show-total
                  @on-change="changePage1()"></Page>
          </div>
        </div>
      </Modal>
    </Drawer>
  </div>
</template>
  
  <script>
export default {
  name: "search-data",
  data () {
    return {
      title: "添加搜索",
      loading: true,
      dataloading: true,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      search_s: {
        //搜索商品等
        key: ""
      },
      columns: [
        {
          title: "新Id",
          key: "id",
          width: 100
          // fixed: 'left'
        },
        {
          title: "原Id",
          key: "quan_id",
          width: 100
          // fixed: 'left'
        },
        {
          title: "来源",
          key: "type_name"
          // fixed: 'left'
        },
        {
          title: "标题",
          key: "good_title"
          // fixed: 'left'
        },
        {
          title: "库存",
          key: "good_store"
          // fixed: 'left'
        },
        {
          title: "销量",
          key: "good_sale"
          // fixed: 'left'
        },
        {
          title: '状态',
          key: 'status',
          width: 100,
          render: (h, params) => {
            return h('div', [
              h('i-switch', {
                props: {
                  value: params.row.status == 1 ? true : false   //控制开关的打开或关闭状态，官网文档属性是value
                },
                on: {
                  'on-change': (value) => {
                    this.changeStatus(params.row.id, value)
                  }
                }
              }, '开关')
            ]);

          }
        },
        {
          title: "操作",
          key: "action",
          align: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id, 1);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      columns1: [
        {
          title: "标题",
          key: "good_title",
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id, 2);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      columns2: [
        // {
        //   type: "selection",
        //   width: 100,
        //   fixed: "left"
        // },
        {
          title: "标题",
          key: "good_title",
          fixed: "left"
        },
        {
          title: "操作",
          key: "action",
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.selectRow(params.row);
                    }
                  }
                },
                "添加"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      tablelist1: [],
      list: [],
      type: "1", //搜索类型1商品2约看
      search: {
        name: "",
        sort: 0
      },
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      pages1: {
        page: 1,
        size: 5,
        total: 0
      },
      pages2: {
        page: 1,
        size: 10,
        total: 0
      },
      showDrawStatus: false,
      showModalStatus: false,
      selected: []
    };
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
    this.getList();
  },
  methods: {
    getColor (index) {
      switch (index % 4) {
        case 0:
          return 'primary'
        case 1:
          return 'success'
        case 2:
          return 'error'
        case 3:
          return 'gold'
      }
    },
    getTableList: function () {
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.giveawardku.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 展开添加
    showDraw (index) {
      this.type = index;
      this.showDrawStatus = !this.showDrawStatus;
      var ps = {
        page: this.pages2.page,
        size: this.pages2.size,
        type: this.type
      };
      this.$api.giveawardku.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist1 = res.result.list;
          // var sl = [];
          // for (let i = 0; i < this.tablelist1.length; i++) {
          //   const item = this.tablelist1[i];
          //   sl.push(item);
          // }
          // this.selected = sl;
          this.pages2.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      this.getList();
    },
    getList: function () {
      this.renderTable1();
    },

    //展开选择
    showModel (index) {
      this.search_s.key = "";
      this.pages1.page = 1
      this.getList();
      this.showModalStatus = true;
      var sl = [];

      for (let i = 0; i < this.tablelist1.length; i++) {
        const item = this.tablelist1[i];
        sl.push(item);
      }
      this.selected = sl
    },
    // 添加
    createHot (name) {
      this.$api.giveawardku
        .create({ data: this.tablelist1, type: this.type })
        .then(res => {
          if (res.code == 200) {
            // this.showDrawStatus = !this.showDrawStatus;
            this.renderTable();
          } else {
            this.showModalStatus = true;
          }
        });
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    remove: function (index, sorce) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.giveawardku.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              if (sorce == 2) {
                var ps = {
                  page: this.pages2.page,
                  size: this.pages2.size,
                  type: this.type
                };
                this.$api.giveawardku.list(ps).then(res => {
                  this.dataloading = false;
                  if (res.code == 200) {
                    this.tablelist1 = res.result.list;
                    this.pages2.total = res.result.total;
                  }
                });
              } else {
                this.getTableList();
              }
            }
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 翻页
    changePage1 () {
      this.pages1.page = this.$refs["listPage1"].currentPage;
      this.renderTable1(1);
    },
    changePage2 () {
      this.pages2.page = this.$refs["listPage2"].currentPage;
      this.renderTable2(1);
    },
    //
    renderTable2: function (name) {
      if (name != 1) {
        this.pages2.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages2.page,
        size: this.pages2.size,
        type: this.type
      };
      this.$api.giveawardku.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist1 = res.result.list;
          this.pages2.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages.page,
        size: this.pages.size
      };
      this.$api.giveawardku.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 筛选
    renderTable1: function (name) {
      var that = this;
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        page: this.pages1.page,
        size: this.pages1.size
      };
      if (this.search_s.key) {
        ps.key = this.search_s.key;
      }
      if (this.type == 1) {
        this.$api.giveawardku.goodlist(ps).then(res => {
          that.dataloading = false;
          if (res.code == 200) {
            var list = res.result.list;
            for (let i = 0; i < list.length; i++) {
              const item = list[i];
              for (let j = 0; j < that.selected.length; j++) {
                const ttt = that.selected[j];
                if (item.good_id == ttt.hot_id) {
                  item._checked = true;
                }
              }
            }
            that.list = list;
            that.pages1.total = res.result.total;
            that.$Message.success(res.msg);
          }
        });
      } else if (this.type == 2) {
        this.$api.lives.list(ps).then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            var list = res.result.list;
            for (var i in list) {
              const item = list[i];
              item.good_title = item.title;
              item.good_id = item.id;
              for (let j = 0; j < that.selected.length; j++) {
                const ttt = that.selected[j];
                if (item.good_id == ttt.hot_id) {
                  item._checked = true;
                }
              }
            }
            that.list = list;
            that.pages1.total = res.result.total;
            that.$Message.success(res.msg);
          }
        });
      } else if (this.type == 3) {
        this.$api.tradesman.list(ps).then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            var list = res.result.list;
            for (var i in list) {
              const item = list[i];
              item.good_title = item.nickname;
              item.good_id = item.id;
              for (let j = 0; j < that.selected.length; j++) {
                const ttt = that.selected[j];
                if (item.good_id == ttt.hot_id) {
                  item._checked = true;
                }
              }
            }
            that.list = list;
            that.pages1.total = res.result.total;
            that.$Message.success(res.msg);
          }
        });
      } else if (this.type == 4) {
        this.$api.intangibleItem.list(ps).then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            var list = res.result.list;
            for (var i in list) {
              const item = list[i];
              item.good_title = item.title;
              item.good_id = item.id;
              for (let j = 0; j < that.selected.length; j++) {
                const ttt = that.selected[j];
                if (item.good_id == ttt.hot_id) {
                  item._checked = true;
                }
              }
            }
            that.list = list;
            that.pages1.total = res.result.total;
            that.$Message.success(res.msg);
          }
        });
      } else if (this.type == 5) {
        this.$api.custommade.list(ps).then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            var list = res.result.list;
            for (var i in list) {
              const item = list[i];
              item.good_title = item.title;
              item.good_id = item.id;
              for (let j = 0; j < that.selected.length; j++) {
                const ttt = that.selected[j];
                if (item.good_id == ttt.hot_id) {
                  item._checked = true;
                }
              }
            }
            that.list = list;
            that.pages1.total = res.result.total;
            that.$Message.success(res.msg);
          }
        });
      }
      return;
    },
    selectRow (row) {
      for (let i = 0; i < this.selected.length; i++) {
        const temp = this.selected[i];
        if (row.id) {
          if (row.id == temp.quan_id || row.id == temp.good_id) {
            this.$Message.error('已添加')
            return
          }
        } else if (row.quan_id) {
          if (row.quan_id == temp.quan_id || row.quan_id == temp.good_id) {
            this.$Message.error('已添加')
            return
          }
        }
      }
      // if (!row.good_title) {
      //   row.title = row.good_title
      // }
      this.selected.push(row);
    },
    cancelRow (item, index) {
      var list = [];
      for (let i = 0; i < this.selected.length; i++) {
        const temp = this.selected[i];
        if (index != i) {
          list.push(temp);
        }
      }
      this.selected = list;
    },
    //选中提交
    ok () {
      console.log(2);
      var list = [];
      for (let i = 0; i < this.selected.length; i++) {
        const item = this.selected[i];
        list.push(item);
      }
      this.tablelist1 = list;
      this.pages.total = list.length
      this.createHot()
    },
    // 修改排序
    editSort: function (index, value) {
      this.$api.giveawardku.sort({ id: index, sort: value }).then(res => {
        if (res.code == 200) {
          this.renderTable(1);
          this.$Message.success(res.msg);
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.giveawardku.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable(1);
        }
      });
    },
  }
};
  </script>
  <style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
/* /deep/.ivu-icon-ios-close:before {
      position: absolute;
      top: -7px;
      right: -2px;
  } */
</style>
  